import React, {useState} from "react";


const Context = React.createContext([]);


export function UserContextProvider({children}){
    const [isLogged, setIsLogged] = useState(() => {
        return sessionStorage.getItem("isLogged") === "true";
    });
    const [usuario, setUsuario] = useState(() => {
        return sessionStorage.getItem("usuario") || null;
    });

    const login = (nombre) => {
        setUsuario(nombre);
        setIsLogged(true);
        sessionStorage.setItem("isLogged", "true");
        sessionStorage.setItem("usuario", nombre);
    };

    const logout = () => {
        setUsuario(null);
        setIsLogged(false);
        sessionStorage.removeItem("isLogged");
        sessionStorage.removeItem("usuario");
    };

    return <Context.Provider value={{isLogged, setIsLogged, usuario, setUsuario, login, logout}}>
        {children}
    </Context.Provider>

}

export default Context;